export default __webpack_public_path__ + "static/media/ToolBelt_login_logo.dd9df130.png";